import { RealTimeAction } from '@/_core/fluxstore/types';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { createSaveCardDescriptionCommand } from '../../../api/commands/factory/createSaveCardDescriptionCommand';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SaveCardDescription extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveCardDescription';

    public constructor(public id: string, public description: string, public isDispatchedByDetailsModal: boolean = false, public isCurrent?: () => boolean) {
        super(SaveCardDescription.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveCardDescription): Promise<boolean> => {
    if (action.isCurrent && !action.isCurrent()) return false;
    if (action.isDispatchedByDetailsModal) {
        return true;
    }

    return await useSendCommandAsync(action, {
        createCommand: () => createSaveCardDescriptionCommand(action),
    });
};

const reducer = (state: StorymapState, action: SaveCardDescription): void => {
    // Throw before Flux broadcasts: middleware approval can become obsolete during its awaited handoff.
    if (action.isCurrent && !action.isCurrent()) throw new Error('Obsolete editor reconciliation');
    const card = getCardById(action.id);

    if (card) {
        card.hasDescription = action.description != null && action.description.trim() != '';
        card.description = action.description;
        card.lastUpdatedAt = new Date();

        if (!action.isDispatchedByRealTimeCallback) {
            dispatch(new FlashJustDragged());
        }
    }
};

//@ts-ignore
registerMiddleware(SaveCardDescription.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveCardDescription.ACTION_TYPE, reducer);
